import { render } from "./AddLawyerToEstateModal.vue?vue&type=template&id=eef988e0&scoped=true&ts=true&lang=pug"
import script from "./AddLawyerToEstateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddLawyerToEstateModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddLawyerToEstateModal.vue?vue&type=style&index=0&id=eef988e0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef988e0"]])

export default __exports__